<template>
    <div class="nav-box">
        <div class="main-bar flex b">
            <router-link :to="{name:'home'}">
                <img class="logo" src="@/assets/images/logo_new.png" alt="">
            </router-link>
            <div class="nav flex pc-show">
                <router-link :to="{name:'home'}" active-class="active" exact>首页</router-link>
                <router-link :to="{name:'introduce'}" active-class="active">平台介绍</router-link>
                <router-link :to="{name:'cooperation'}" active-class="active">银行合作</router-link>
                <router-link :to="{name:'enterprise'}" active-class="active">企业授信预查</router-link>
                <router-link :to="{name:'join'}" active-class="active">信贷经理加盟</router-link>
                <router-link :to="{name:'productList'}" active-class="active" v-if="hasLoginFlag">我的小逸</router-link>
                <router-link :to="{name:'login'}" active-class="active" v-else>登录/注册</router-link>
                <router-link :to="{name:'news'}" active-class="active">新闻资讯</router-link>
                <router-link :to="{name:'contact'}" active-class="active">联系我们</router-link>
            </div>

            <div class="nav flex mob-show" v-show="navShow" @click="navClick">
                <router-link :to="{name:'home'}" active-class="active" exact>首页</router-link>
                <router-link :to="{name:'introduce'}" active-class="active">平台介绍</router-link>
                <router-link :to="{name:'cooperation'}" active-class="active">银行合作</router-link>
                <router-link :to="{name:'enterprise'}" active-class="active">企业授信预查</router-link>
                <router-link :to="{name:'join'}" active-class="active">信贷经理加盟</router-link>
                <router-link :to="{name:'productList'}" active-class="active" v-if="hasLoginFlag">我的小逸</router-link>
                <router-link :to="{name:'login'}" active-class="active" v-else>登录/注册</router-link>
                <router-link :to="{name:'news'}" active-class="active">新闻资讯</router-link>
                <router-link :to="{name:'contact'}" active-class="active">联系我们</router-link>
            </div>
            <div class="mob-show">
                <span class="icon iconfont el-close" v-show="navShow==true" @click="navShow=false"></span>
                <span class="icon iconfont el-imenu" v-show="navShow==false" @click="navShow=true"></span>
            </div>

        </div>
    </div>
</template>

<script>
  export default {
    name: "headerBar",
    data() {
      return {
        hasLoginFlag:false,
        navShow:false
      };
    },
    created(){
      if(localStorage.loginToken){
        this.$store.commit('setLogin',true);
      }
    },
    computed: {
      hasLogin() {
        return this.$store.state.hasLogin;
      }
    },
    watch: {
      hasLogin(val) {
        this.hasLoginFlag=val;
      }
    },
    mounted() {
    },
    methods: {
      navClick(){
        setTimeout(()=>{
          this.navShow=false;
        },30)
      }
    }

  };
</script>

<style scoped lang="less" type="text/less">
    .nav-box{
        height: 80px;
        box-shadow: 0px 2px 4px 0px rgba(170,170,170,0.3);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 5;
        background: #fff;
        font-size: 18px;
        color: #666;
    }
    .logo{
        height: 70px;
    }
    .nav{
        height: 80px;
        .active{color: #229E7F;}
        .active::after{
            content: '';
            position: absolute;
            background: #229E7F;
            width: 30px;
            height: 4px;
            left: 1px;
            bottom: 0;
        }
        a{
            height: 100%;
            line-height: 80px;
            margin-left: 28px;
            position: relative;
        }
        a:hover{
            color: #229E7F;
        }
    }


</style>
